import { SortingConfig } from '@customer-portal/shared/models';

export class SetUnsavedFilters {
  static readonly type = '[UnsavedFilters] Set Filters';

  constructor(
    public pageKey: string,
    public filters: any,
  ) {}
}

export class SetUnsavedPaginationStartIndex {
  static readonly type = '[UnsavedFilters] Set Pagination Start Index';

  constructor(
    public pageKey: string,
    public startIndex: number,
  ) {}
}

export class GetUnsavedFilters {
  static readonly type = '[UnsavedFilters] Get Filters';

  constructor(public pageKey: string) {}
}

export class SetUnsavedSorting {
  static readonly type = '[UnsavedFilters] Set Sorting';

  constructor(
    public pageKey: string,
    public sorting: SortingConfig,
  ) {}
}

export class ClearUnsavedFilters {
  static readonly type = '[UnsavedFilters] Clear Filters';

  constructor(public pageKey: string) {}
}

export class ClearUnsavedPaginationStartIndex {
  static readonly type = '[UnsavedFilters] Clear Pagination Start Index';

  constructor(public pageKey: string) {}
}

export class ClearAllUnsavedFilters {
  static readonly type = '[UnsavedFilters] Clear All Filters';
}
